export default __webpack_public_path__ + "static/media/starfill.2f0af7cf.svg";